var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "act-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm.activityStatus === "on"
        ? [
            _c(
              "div",
              {
                staticClass: "act-top",
                style: { marginTop: `-${_vm.barHeight + 46}px` },
              },
              [
                _c("div", { staticClass: "top-block" }, [
                  _c("div", { style: { height: `${_vm.barHeight + 46}px` } }),
                  _c("p", { staticClass: "act-tit1" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k351"))),
                  ]),
                  _c("p", { staticClass: "act-tit2" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k352"))),
                  ]),
                  _c("div", { staticClass: "rec-date-block" }, [
                    _c("div", { staticClass: "clock" }),
                    _c("div", { staticClass: "dead-line" }, [
                      _c("div", { staticClass: "num time" }, [
                        _vm._v(_vm._s(_vm.countdownResult.days)),
                      ]),
                      _c("div", { staticClass: "union" }, [
                        _vm._v(_vm._s(_vm.$t("lang.commonM.k297"))),
                      ]),
                      _c("div", { staticClass: "num step" }, [_vm._v(" : ")]),
                      _c("div", { staticClass: "num time" }, [
                        _vm._v(_vm._s(_vm.countdownResult.hours)),
                      ]),
                      _c("div", { staticClass: "union" }, [
                        _vm._v(_vm._s(_vm.$t("lang.commonM.k364"))),
                      ]),
                      _c("div", { staticClass: "num step" }, [_vm._v(" : ")]),
                      _c("div", { staticClass: "num time" }, [
                        _vm._v(_vm._s(_vm.countdownResult.minutes)),
                      ]),
                      _c("div", { staticClass: "union" }, [
                        _vm._v(_vm._s(_vm.$t("lang.commonM.k365"))),
                      ]),
                      _c("div", { staticClass: "num step" }, [_vm._v(" : ")]),
                      _c("div", { staticClass: "num time" }, [
                        _vm._v(_vm._s(_vm.countdownResult.seconds)),
                      ]),
                      _c("div", { staticClass: "union" }, [
                        _vm._v(_vm._s(_vm.$t("lang.commonM.k366"))),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "act-con act-con-coins" },
              [
                _c("div", { staticClass: "rec-fir-deliver" }, [
                  _vm._m(0),
                  _vm.baseInfo && _vm.baseInfo.activityGroup === "A"
                    ? _c("div", { staticClass: "rec-fir-deliver-text" }, [
                        _vm._v(_vm._s(_vm.$t("lang.commonM.k353"))),
                      ])
                    : _vm._e(),
                  _vm.baseInfo && _vm.baseInfo.activityGroup === "B"
                    ? _c("div", { staticClass: "rec-fir-deliver-text" }, [
                        _vm._v(_vm._s(_vm.$t("lang.commonM.k354"))),
                      ])
                    : _vm._e(),
                  _vm._m(1),
                ]),
                _c("div", { staticClass: "rec-coins" }, [
                  _c("div", { staticClass: "rec-coins-left" }, [
                    _c("div", { staticClass: "rec-coins-tit" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k302"))),
                    ]),
                    _vm.baseInfo
                      ? _c("div", { staticClass: "rec-coins-num" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coin") },
                          }),
                          _vm._v(_vm._s(_vm.baseInfo.originAmount) + " "),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._m(2),
                  _c("div", { staticClass: "rec-coins-right" }, [
                    _c("div", { staticClass: "rec-coins-tit" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k303"))),
                    ]),
                    _vm.baseInfo
                      ? _c("div", { staticClass: "rec-coins-num" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coins") },
                          }),
                          _vm._v(_vm._s(_vm.baseInfo.amount) + " "),
                        ])
                      : _vm._e(),
                  ]),
                  _vm.baseInfo
                    ? _c("div", { staticClass: "rec-coins-discount" }, [
                        _c("i", { staticClass: "plus" }, [_vm._v("+")]),
                        _vm._v(_vm._s(_vm.baseInfo.discountDesc) + " "),
                      ])
                    : _vm._e(),
                ]),
                _vm.baseInfo
                  ? [
                      _vm.baseInfo.ifClickable === true
                        ? _c(
                            "div",
                            {
                              staticClass: "rec-coins-btn",
                              on: { click: _vm.handleClaim },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("imgPath")(
                                    _vm.baseInfo.currencyIcon
                                  ),
                                },
                              }),
                              _c("div", [
                                _c("i", [
                                  _vm._v(_vm._s(_vm.baseInfo.currency)),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.handleDiv100(_vm.baseInfo.price))
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _c("div", { staticClass: "rec-coins-btn disable" }, [
                            _c("img", {
                              attrs: {
                                src: _vm._f("imgPath")(
                                  _vm.baseInfo.currencyIcon
                                ),
                              },
                            }),
                            _c("div", [
                              _c("i", [_vm._v(_vm._s(_vm.baseInfo.currency))]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.handleDiv100(_vm.baseInfo.price))
                                ),
                              ]),
                            ]),
                          ]),
                    ]
                  : _vm._e(),
                _c("p", { staticClass: "rec-coins-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k355"))),
                ]),
              ],
              2
            ),
            _c("div", { staticClass: "act-con act-con-pan" }, [
              _c("div", { staticClass: "rec-fir-deliver" }, [
                _vm._m(3),
                _c("div", { staticClass: "rec-fir-deliver-text" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k384"))),
                ]),
                _vm._m(4),
              ]),
              _c("div", { staticClass: "wheel-pan-block" }, [
                _c("div", { staticClass: "wheel-pan" }, [
                  _c("div", { staticClass: "outher" }, [
                    _vm.baseInfo
                      ? _c("div", { ref: "wapper", staticClass: "wapper" }, [
                          _c("div", { staticClass: "part1" }, [
                            _vm.panData && _vm.panData[0]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item one",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[0].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[0].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[0].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[0]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[0].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[0]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.panData && _vm.panData[1]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item two",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[1].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[1].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[1].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[1]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[1].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[1]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.panData && _vm.panData[2]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item three",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[2].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[2].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[2].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[2]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[2].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[2]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.panData && _vm.panData[3]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item four",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[3].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[3].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[3].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[3]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[3].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[3]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "part2" }, [
                            _vm.panData && _vm.panData[4]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item five",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[4].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[4].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[4].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[4]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[4].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[4]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.panData && _vm.panData[5]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item six",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[5].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[5].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[5].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[5]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[5].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[5]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.panData && _vm.panData[6]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item seven",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[6].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[6].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[6].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[6]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[6].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[6]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.panData && _vm.panData[7]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item eight",
                                    class: {
                                      got: _vm.gotDrawnId === _vm.panData[7].id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text" },
                                      [
                                        _vm.panData[7].type === "props"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "video-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[7].reward[2]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pan-txt-item" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "super-chat-pass"
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "x" +
                                                      _vm._s(
                                                        _vm.panData[7]
                                                          .reward[15]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm.panData[7].type === "coins"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "pan-num-item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "discount" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.panData[7]
                                                            .reward[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.getMatchImg(
                                                        "coins"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "wheel-pointer" }),
                ]),
                _c("div", { staticClass: "wheel-base" }),
                _c("div", { staticClass: "wheel-tips" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k356")) + " "),
                  _c("i", [_vm._v(_vm._s(_vm.spinCount))]),
                ]),
              ]),
              _c("p", { staticClass: "rec-coins-tips in-pan" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k357"))),
              ]),
              _vm.spinCount > 0
                ? _c(
                    "div",
                    {
                      staticClass: "rec-coins-btn",
                      on: { click: _vm.handleWheelPan },
                    },
                    [_c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k358")))])]
                  )
                : _c("div", { staticClass: "rec-coins-btn disable" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k358")))]),
                  ]),
            ]),
            _c("div", { staticClass: "act-tips" }, [
              _c("div", { staticClass: "act-tips-tit" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k359"))),
              ]),
              _c("div", { staticClass: "act-tips-con" }, [
                _vm._v(" 1.  "),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k360")))]),
              ]),
              _c("div", { staticClass: "act-tips-con" }, [
                _vm._v(" 2.  "),
                _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k361")))]),
              ]),
            ]),
            _vm.showDia
              ? _c("div", { staticClass: "mask" }, [
                  _c("div", { staticClass: "dialog" }, [
                    _c("div", { staticClass: "dia-tit" }, [
                      _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k362")))]),
                      _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k363")))]),
                    ]),
                    _vm.gotObj
                      ? _c(
                          "div",
                          { staticClass: "dia-con" },
                          [
                            _vm.gotObj.type === "props"
                              ? [
                                  _c("div", { staticClass: "gift-item" }, [
                                    _c("div", { staticClass: "gift-icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.getMatchImg("video-pass"),
                                        },
                                      }),
                                    ]),
                                    _vm.gotObj.reward
                                      ? _c("div", { staticClass: "gift-num" }, [
                                          _vm._v(
                                            "x" + _vm._s(_vm.gotObj.reward[2])
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _c("div", { staticClass: "gift-gap" }),
                                  _c("div", { staticClass: "gift-item" }, [
                                    _c("div", { staticClass: "gift-icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.getMatchImg(
                                            "super-chat-pass"
                                          ),
                                        },
                                      }),
                                    ]),
                                    _vm.gotObj.reward
                                      ? _c("div", { staticClass: "gift-num" }, [
                                          _vm._v(
                                            "x" + _vm._s(_vm.gotObj.reward[15])
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm.gotObj.type === "coins"
                              ? [
                                  _c("div", { staticClass: "gift-item" }, [
                                    _c("div", { staticClass: "gift-icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.getMatchImg("coins"),
                                        },
                                      }),
                                    ]),
                                    _vm.gotObj.reward
                                      ? _c("div", { staticClass: "gift-num" }, [
                                          _vm._v(
                                            "x" + _vm._s(_vm.gotObj.reward[0])
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "dia-btn",
                        on: { click: _vm.handleGotOk },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.activityStatus === "off" ? [_c("ActEnd")] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-l" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-r" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rec-coins-center" }, [
      _c("div", { staticClass: "up-img" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-l" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-r" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }